export const translations = {
    es: {
        nav: {
            servicios: "Servicios",
            galeria: "Galería",
            testimonios: "Testimonios",
            horario: "Horario",
            contacto: "Contacto",
        },
        book: "Reservar Cita",
        hero: {
            whatsapp: "Reservar por WhatsApp",
            services: "Ver Servicios",
            reviews: "reseñas en Google",
        },
        services: {
            eyebrow: "Nuestros Servicios",
            all: "Todos",
            empty: "No hay servicios en esta categoría todavía.",
        },
        gallery: {
            eyebrow: "Galería",
            title: "Nuestro trabajo habla por sí solo",
            all: "Todos",
            empty: "Aún no hay imágenes en esta categoría.",
        },
        testimonials: {
            eyebrow: "Testimonios",
            title: "Lo que dicen nuestros clientes",
            basedOn: "Basado en {n} reseñas verificadas",
            seeGoogle: "Ver reseñas en Google",
            empty: "Las reseñas de nuestros clientes llegarán muy pronto. Mientras tanto, mira las {n} reseñas en Google.",
        },
        hours: {
            eyebrow: "Visítanos",
            title: "Horario y Ubicación",
            openHours: "Horario de atención",
            openNow: "Abierto ahora",
            closed: "Cerrado",
            today: "Hoy",
            copy: "Copiar",
            copied: "Copiada",
            directions: "Cómo llegar",
            city: "Peekskill, Nueva York",
        },
        contact: {
            eyebrow: "Reservas",
            title: "Reserva tu cita",
            subtitle: "Escríbenos por WhatsApp o déjanos tus datos y te contactamos para confirmar tu hora.",
            messageUs: "Escríbenos ahora mismo",
            phone: "Teléfono",
            address: "Dirección",
            name: "Nombre *",
            phoneLabel: "Teléfono *",
            service: "Servicio",
            date: "Fecha",
            time: "Hora",
            message: "Mensaje",
            selectService: "Selecciona un servicio",
            other: "Otro",
            namePh: "Tu nombre",
            phonePh: "(914) 000-0000",
            msgPh: "Cuéntanos qué necesitas...",
            sending: "Enviando...",
            send: "Enviar solicitud",
            sendWa: "Enviar por WhatsApp",
            errRequired: "Por favor completa tu nombre y teléfono",
            toastError: "No se pudo enviar la solicitud. Inténtalo de nuevo.",
            toastOk: "¡Solicitud enviada! Te contactaremos pronto.",
        },
        footer: { rights: "Todos los derechos reservados." },
        wa: {
            hero: "Hola {name}, quisiera reservar una cita",
            greet: "Hola {name}, quisiera reservar una cita:",
            name: "Nombre",
            phone: "Teléfono",
            service: "Servicio",
            date: "Fecha",
            time: "Hora",
            message: "Mensaje",
        },
        whatsappAria: "Escríbenos por WhatsApp",
        days: {
            Lunes: "Lunes",
            Martes: "Martes",
            "Miércoles": "Miércoles",
            Jueves: "Jueves",
            Viernes: "Viernes",
            "Sábado": "Sábado",
            Domingo: "Domingo",
        },
        cats: {
            "Cosmetología": "Cosmetología",
            "Barbería": "Barbería",
            "Estética": "Estética",
            Spa: "Spa",
        },
    },
    en: {
        nav: {
            servicios: "Services",
            galeria: "Gallery",
            testimonios: "Testimonials",
            horario: "Hours",
            contacto: "Contact",
        },
        book: "Book Appointment",
        hero: {
            whatsapp: "Book via WhatsApp",
            services: "View Services",
            reviews: "Google reviews",
        },
        services: {
            eyebrow: "Our Services",
            all: "All",
            empty: "No services in this category yet.",
        },
        gallery: {
            eyebrow: "Gallery",
            title: "Our work speaks for itself",
            all: "All",
            empty: "No images in this category yet.",
        },
        testimonials: {
            eyebrow: "Testimonials",
            title: "What our clients say",
            basedOn: "Based on {n} verified reviews",
            seeGoogle: "Read reviews on Google",
            empty: "Client reviews are coming soon. In the meantime, check out the {n} Google reviews.",
        },
        hours: {
            eyebrow: "Visit Us",
            title: "Hours & Location",
            openHours: "Opening Hours",
            openNow: "Open now",
            closed: "Closed",
            today: "Today",
            copy: "Copy",
            copied: "Copied",
            directions: "Directions",
            city: "Peekskill, New York",
        },
        contact: {
            eyebrow: "Bookings",
            title: "Book your appointment",
            subtitle: "Message us on WhatsApp or leave your details and we'll contact you to confirm your appointment.",
            messageUs: "Message us now",
            phone: "Phone",
            address: "Address",
            name: "Name *",
            phoneLabel: "Phone *",
            service: "Service",
            date: "Date",
            time: "Time",
            message: "Message",
            selectService: "Select a service",
            other: "Other",
            namePh: "Your name",
            phonePh: "(914) 000-0000",
            msgPh: "Tell us what you need...",
            sending: "Sending...",
            send: "Send request",
            sendWa: "Send via WhatsApp",
            errRequired: "Please fill in your name and phone",
            toastError: "Couldn't send your request. Please try again.",
            toastOk: "Request sent! We'll contact you soon.",
        },
        footer: { rights: "All rights reserved." },
        wa: {
            hero: "Hi {name}, I'd like to book an appointment",
            greet: "Hi {name}, I'd like to book an appointment:",
            name: "Name",
            phone: "Phone",
            service: "Service",
            date: "Date",
            time: "Time",
            message: "Message",
        },
        whatsappAria: "Message us on WhatsApp",
        days: {
            Lunes: "Monday",
            Martes: "Tuesday",
            "Miércoles": "Wednesday",
            Jueves: "Thursday",
            Viernes: "Friday",
            "Sábado": "Saturday",
            Domingo: "Sunday",
        },
        cats: {
            "Cosmetología": "Cosmetology",
            "Barbería": "Barber Shop",
            "Estética": "Esthetics",
            Spa: "Spa",
        },
    },
};
